<template>
  <div>
    <div class="list-group">
      <question v-if="question" :question="question" />
    </div>
    <button class="btn btn-success" @click="$router.push('/questions')">
      <span class="text-nowrap">
        <i class="fa fa-angle-left"></i> Ver preguntas
      </span>
    </button>
  </div>
</template>

<script>
import { getQuestionApi } from "@/api/modules";
import { mapActions } from "vuex";
const Question = () => import("./Question");
export default {
  props: ["id"],
  data() {
    return {
      question: null
    };
  },
  components: {
    Question
  },
  created() {
    this.getQuestion();
  },
  methods: {
    ...mapActions(["addMessage"]),
    async getQuestion() {
      const serviceResponse = await getQuestionApi(this.id);
      if (serviceResponse.status) {
        this.question = serviceResponse.data;
      } else {
        let message_obj = {
          message: serviceResponse.message.text,
          messageClass: "danger",
          autoClose: true
        };
        this.addMessage(message_obj);
        this.$router.push("/");
      }
      return serviceResponse.status;
    }
  }
};
</script>

<style>
</style>